import * as actionTypes from "Redux/Actions/actionTypes";

const doCheckExistingUser = (userdata) => {
  return {
    type: actionTypes.EXISTINGUSER_REQUEST,
    data: userdata,
  };
};

export default doCheckExistingUser;
